import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ActiveTerm } from './tenant-signup.types';

@Injectable({ providedIn: 'root' })
export class PublicTermsService {
  private readonly http = inject(HttpClient);

  getActiveTerms(): Observable<ActiveTerm[]> {
    return this.http.get<ActiveTerm[]>(environment.publicTermsUrl);
  }
}
